import React, { useState } from "react";
import "./main_page.scss";
import strings from "../../../constants/strings";
import ProductCard from "../../reusable/ProductCard/ProductCard";
import ListIndicator from "../../reusable/ListIndicator/ListIndicator";
import { mockBestsellers, mockNew, mockPromotion } from "../../../constants/mockData";

const commonData = [
  { id: 1, title: strings.bestsellers, data: mockBestsellers },
  { id: 2, title: strings.new, data: mockNew },
  { id: 3, title: strings.products_for_promotion, data: mockPromotion },
];
const MainPage = () => {
  const [page, setPage] = useState(1);
  return (
    <div className="main-page">
      <div className="main-page__inner">
        {commonData.map((item) => (
          <div key={item.id} className="main-page__card">
            <div className="main-page__title">{item.title}</div>
            <div className="main-page__card__inner">
              {item.data.map((item) => (
                <ProductCard key={item.id} data={item} />
              ))}
            </div>
            <div className="main-page__indicator__container">
              <ListIndicator
                pointAmount={3}
                activePoint={page}
                setPoint={setPage}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainPage;
